import { useContext } from "react"
import { Injector } from "../../../modules/di/Injector"
import { InjectorContext } from "../InjectorContext"

export const useInjector = (): Injector => useContext(InjectorContext)
